import {
    Alert,
    Box,
    Button,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography,
    FormHelperText,
    Grid, Paper, Container,
    Backdrop,
    CircularProgress
} from "@mui/material";
import { useEffect, useState } from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import useAdminProfileUtils from "../../ProfilePlugin/utils/useAdminProfileUtils";
import DriverService from "../services/api";
import { useSnackbar } from "notistack";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import CustomHeader from "../../../core/components/common/custom-header.component";
import CustomTextField from "../../../core/components/ui/CustomTextfield";
import CustomButton from "../../../core/components/ui/CustomButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import CustomModal1 from "../../../core/components/ui/custom-modal1.component";
import SavePasswordDialogComponent from "../../OrganizationPlugin/components/save-password-dialog.component";

export default function CreateDriverPage({}) {
    const rbacStorage = JSON.parse(localStorage.getItem("rbac-storage"));
    const org_uid = rbacStorage?.state?.currentProfile?.orgId || null;
    
    const view_org_uid = new URLSearchParams(window.location.search).get("org_uid");

    const organizationId = view_org_uid || org_uid;

    const { isFetchingIDTypes, idTypes, getIDTypesUtil } = useAdminProfileUtils();
    const { enqueueSnackbar } = useSnackbar();

    const [firstname, setFirstname] = useState('');
    const [middlename, setMiddleName] = useState("");
    const [lastname, setLastname] = useState('');
    const [email, setEmail] = useState('');
    const [birthdate, setBirthdate] = useState(null);
    const [id_type, setIDType] = useState('');
    const [id_no, setIdNumber] = useState('');
    const [contact_no, setContactNo] = useState('');


    const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState();
    const [statusCode, setStatusCode] = useState();

    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [openSavePassword, setOpenSavePassword] = useState(false);
    const [createUserData, setCreateUserData] = useState({});

    const today = dayjs();
    const maxAllowedDate = today.subtract(16, 'year');

    const navigate = useNavigate();

    const handleSelect = (setter) => (event) => {
        setter(event.target.value);
    };

    const handleBack = () => {
        navigate(-1)
    }

    const validateEmailField = (value) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        setErrors((prev) => ({
            ...prev,
            email: value === ''
            ? 'Email is required'
            : !emailRegex.test(value)
            ? 'Invalid email format'
            : '',
        }));
    };

    const validateFields = () => {
        const newErrors = {};

        if (!firstname) newErrors.firstname = "First name is required";
        if (!lastname) newErrors.lastname = "Last name is required";
        if (!contact_no) newErrors.contact_no = "Contact number is required";

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email) newErrors.email = "Email is required";
        else if (!emailRegex.test(email)) newErrors.email = "Invalid email format";

        if (!birthdate) newErrors.birthdate = "Birthdate is required";
        if (!id_type) newErrors.id_type = "ID type is required";
        if (!id_no) newErrors.id_no = "ID number is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleClose = () => {
        setOpenSavePassword(false);
    }

    const handleSubmit = async () => {
        if (!validateFields()) return;

        const payload = {
            firstname,
            middlename,
            lastname,
            email,
            birthdate: dayjs(birthdate).format("YYYY-MM-DD"),
            profile_type: "Business",
            contact_no,
            id_type,
            id_no,
            role: "BusinessDriver",
            org_uid: organizationId,
        };

        setLoading(true);

        console.log('get driver payload', payload)

        try {
            const result = await DriverService.createDriver(payload);
            setLoading(false);
            setSuccess(true);
            setOpenSavePassword(true);
            setCreateUserData(result?.data?.data?.user);
            // handleUpdateList()
            // window.location.reload()
            console.log("Driver created successfully", result.data);
        } catch (error) {
            setSuccess(false);
            setStatusCode(error?.response?.status || 500);

            const message = error?.response?.data?.error_message || error.message || "An unexpected error occurred";
            setErrorMessage(message);

            enqueueSnackbar(message, {
                variant: "error",
                autoHideDuration: 4000,
            });

            console.error("Error creating driver:", error);
        } 
    };

    const isFormValid =
    firstname.trim() !== '' &&
    lastname.trim() !== '' &&
    email.trim() !== '' &&
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) &&
    contact_no.trim() !== '' &&
    birthdate !== null &&
    id_type.trim() !== '' &&
    id_no.trim() !== '';



    useEffect(() => {
        getIDTypesUtil();
    }, []);

    return (
        <Container maxWidth="lg">
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1, }}
                open={loading}
            >
                <Box display="flex" flexDirection="column" alignItems="center" textAlign="center">
                    <CircularProgress
                        color="inherit"
                        size={60}
                    />
                    <Typography mt={2} sx={{color:"#fff"}}>
                        Creating...
                    </Typography>
                </Box>
                
            </Backdrop>
            <CustomButton                    variant="text" 
                    startIcon={<ArrowBackIcon fontSize="small" />}
                    label="Back to Driver list"
                    customStyles={{fontSize: 14, mt: 2}}
                    onClick={handleBack}
                />
            <Paper elevation={3} sx={{ p: 4, borderRadius: 2, mt: 2 }}>
                <Box sx={{textAlign: "start", mb: 3}}>
                    <Typography variant="h6" >Create Driver</Typography>
                    <Typography> Add a new driver and complete their profile details in one simple step.</Typography>
                </Box>
                <Grid container spacing={3}>
                {/* First Name */}
                <Grid item size={{ xs: 12, sm: 4 }}>
                    <Typography variant="body2" sx={{ fontWeight: 500}}>
                        First Name
                    </Typography>
                    <CustomTextField
                        placeholder={"ex: Juan"}
                        variant={"outlined"}
                        value={firstname}
                        onChange={(e) => setFirstname(e.target.value)}
                        fullWidth={true}
                        multiline={false}
                        hiddenLabel
                        error={!!errors.firstname}
                        helperText={errors.firstname}
                    />
                </Grid>

                <Grid item size={{ xs: 12, sm: 4 }}>
                    
                    <Typography variant="body2" fontWeight={500}>
                    Middle Name
                    </Typography>
                    <CustomTextField
                        variant={"outlined"}
                        value={middlename}
                        onChange={(e) => setMiddleName(e.target.value)}
                        placeholder="Enter middle name"
                        fullWidth
                        multiline={false}
                        hiddenLabel
                        helperText={errors.middlename}
                    />
                </Grid>

                {/* Last Name */}
                <Grid item size={{ xs: 12, sm: 4 }}>
                    <Typography variant="body2" fontWeight={500}>
                    Last Name
                    </Typography>
                    <CustomTextField
                    value={lastname}
                    variant={"outlined"}
                    onChange={(e) => setLastname(e.target.value)}
                    placeholder="Enter last name"
                    fullWidth
                    multiline={false}
                    hiddenLabel
                    helperText={errors.lastname}
                    />
                </Grid>

                {/* Email */}
                <Grid item size={{ xs: 12, sm: 6 }}>
                    <Typography variant="body2" fontWeight={500}>
                    Email
                    </Typography>
                    <CustomTextField
                    variant={"outlined"}
                    value={email}
                    onChange={(e) => {
                        const value = e.target.value;
                        setEmail(value);
                        validateEmailField(value);
                    }}
                    placeholder="Enter email address"
                    fullWidth
                    multiline={false}
                    hiddenLabel
                    helperText={errors.email}
                    />
                </Grid>

                {/* Contact Number */}
                <Grid item size={{ xs: 12, sm: 6 }}>
                    <Typography variant="body2" fontWeight={500}>
                    Contact Number
                    </Typography>
                    <PhoneInput
                    country={'ph'}
                    value={contact_no}
                    onChange={(value) => setContactNo('+' + value)}
                    inputStyle={{
                        width: '100%',
                        height: 45,
                        borderRadius: 4,
                        paddingLeft: 48,
                        border:'1px solid #e5edf6'
                    }}
                    
                    inputProps={{
                    name: 'phone',
                    required: true,
                    }}
                    enableSearch
                    />
                    {errors.contact_no && (
                    <FormHelperText sx={{ color: 'error.main', fontSize: 11, margin: 0 }}>
                        {errors.contact_no}
                    </FormHelperText>
                    )}
                </Grid>

                {/* Date of Birth */}
                <Grid item size={{ xs: 12, sm: 6 }}>
                    <Typography variant="body2" fontWeight={500}>
                    Date of Birth
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        value={birthdate}
                        onChange={(date) => setBirthdate(date)}
                        maxDate={maxAllowedDate}
                        shouldDisableDate={(date) => date.isAfter(maxAllowedDate)}
                        style={{height: 45}}
                                    slotProps={{
                            textField: {
                                fullWidth: true,
                                // error: !!userErrors.birthdate,
                                helperText: errors.birthdate,
                                sx: {
                                    '& .MuiInputBase-root': {
                                        height: 50,
                                        border:'1px solid #fff'
                                    }, '& .MuiFormHelperText-root': {
                                        color: 'red',
                                        fontSize: 11,
                                        margin: 0
                                    }, '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                    borderColor: '#e5edf6', // 🔵 default border color
                                    },
                                },
                                }
                            },
                        }}
                    />
                    </LocalizationProvider>
                </Grid>

                {/* ID Type */}
                <Grid item size={{ xs: 12, sm: 6 }}>
                    <Typography variant="body2" fontWeight={500}>
                    ID Type
                    </Typography>
                    <FormControl fullWidth error={!!errors.id_type}>
                    <Select
                        value={id_type}
                        onChange={handleSelect(setIDType)}
                        displayEmpty
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '4px',
                                '& fieldset': {
                                borderColor: '#e5edf6',
                                },
                            },
                            '& .MuiSelect-select': {
                                padding: '10px 14px',
                                minHeight: '20px', // ✅ Controls the visible height
                                display: 'flex',
                                alignItems: 'center',
                            }
                        }}
                    >
                        <MenuItem value="" disabled>
                        Select ID Type
                        </MenuItem>
                        {idTypes.map((name) => (
                        <MenuItem key={name} value={name}>
                            {name}
                        </MenuItem>
                        ))}
                    </Select>
                    {errors.id_type && (
                        <FormHelperText>{errors.id_type}</FormHelperText>
                    )}
                    </FormControl>
                </Grid>

                {/* ID Number */}
                <Grid item size={{ xs: 12, sm: 6 }}>
                    <Typography variant="body2" fontWeight={500}>
                    ID Number
                    </Typography>
                    <CustomTextField
                        variant={"outlined"}
                        value={id_no}
                        onChange={(e) => setIdNumber(e.target.value)}
                        placeholder="Enter ID number"
                        fullWidth
                        multiline={false}
                        hiddenLabel
                        helperText={errors.id_no}
                    />
                </Grid>

                {/* Submit Button */}
                <Grid item size={{ xs: 12 }} sx={{ textAlign: 'right' }}>
                    <CustomButton 
                        variant={"contained"}
                        label={"Create"}
                        disabled={loading || !isFormValid}
                        // startIcon={isLoadingCreateGate && <CircularProgress size="15px" color="#fff" sx={{mr: "2px"}} />}
                        onClick={handleSubmit}
                    />  
                </Grid>
                </Grid>
            </Paper>

            <CustomModal1
                open={openSavePassword}
                handleClose={handleClose}
                title="Save Password"
            >
                <SavePasswordDialogComponent createUserData={createUserData}/>
            </CustomModal1>
        </Container>
    );

}
